<!--
 * @Description: 安装分区
 * @Author: gao shuai
 * @Date: 2020-07-02 11:21:17
 * @LastEditTime: 2020-07-17 10:18:06
 * @LastEditors: gao shuai
-->
<template>
  <div class="installBox">
    <p class="toptit">分区类型：</p>
    <div class="typeContainer">
      <span :class="{'on':typeindex===1}" @click="changeType(1)">热血传奇</span>
      <span :class="{'on':typeindex===2}" @click="changeType(2)">传奇世界</span>
      <span :class="{'on':typeindex===3}" @click="changeType(3)">传奇3</span>
      <span :class="{'on':typeindex===0}" @click="changeType(0)">sql通用</span>
    </div>
    <p class="tip_text">注意:创建分区前，请先把客户端运行起来</p>
    <dl class="clearfix">
      <dt>分区名称：</dt>
      <dd>
        <span class="inp">
          <input v-model="partName" placeholder="请输入分区名称">
        </span>
        <p class="txt">3-30个字符,请勿输入特殊符号</p>
      </dd>
    </dl>
    <dl class="clearfix">
      <dt></dt>
      <dd>
        <van-checkbox v-model="partChecked" shape="square" checked-color="#1abc9c">在指定时间更改分区名称</van-checkbox>
      </dd>
    </dl>
    <dl class="clearfix" v-if="partChecked">
      <dt>更改名称：</dt>
      <dd>
        <span class="inp">
          <input v-model="changeName" placeholder="请输入更改名称">
        </span>
      </dd>
    </dl>
    <dl class="clearfix" v-if="partChecked">
      <dt>更改时间：</dt>
      <dd>
        <time-selct style="width: 192px;" :value.sync="changeTime"></time-selct>
      </dd>
    </dl>
    <dl class="clearfix">
      <dt>分组：</dt>
      <dd>
        <van-checkbox class="mgt5" v-model="checked" shape="square" checked-color="#1abc9c" @change="checkedtoggle">全选</van-checkbox>
      </dd>
    </dl>
    <van-checkbox-group v-model="grouplist" ref="checkboxGroup">
      <ul class="clearfix checkList">
        <li v-for="(item,i) in areaList" :key="'area'+i">
          <van-checkbox :name="item.id" checked-color="#1abc9c">{{item.name}}</van-checkbox>
        </li>
      </ul>
    </van-checkbox-group>
    <dl class="clearfix mgt10">
      <dt>网关标识：</dt>
      <dd>
        <span class="inp">
          <!-- <input v-model="serverIp" placeholder="请输入更改名称"> -->
          <slector class="width190" title="网关标识" :columns="serverDrow" :value.sync="serverIp"></slector>
        </span>
        <p class="txt">您的游戏服务器IP和网关通讯端口</p>
      </dd>
    </dl>
    <dl class="clearfix" v-if="typeindex!==0">
      <dt>安装路径：</dt>
      <dd>
        <span class="inp width190">
          <input v-model="installPath" placeholder="请输入更改名称">
        </span>
        <p class="txt">安装脚本目录或INI文件存放路径</p>
      </dd>
    </dl>
    <dl class="clearfix">
      <dt>模板：</dt>
      <dd>
        <slector class="width190" title="模板" :columns="modelDrow" :value.sync="installModel"></slector>
      </dd>
    </dl>
    <dl class="clearfix" v-if="typeindex!==3&&typeindex!==0">
      <dt>元宝蛋：</dt>
      <dd>
        <van-radio-group class="mgt5" v-model="glodEgg" direction="horizontal">
          <van-radio :name="true" checked-color="#07c160">开启</van-radio>
          <van-radio :name="false" checked-color="#07c160">关闭</van-radio>
        </van-radio-group>
      </dd>
    </dl>
    <div class="noticebox">
      <p class="txt">分区公告：</p>
      <textarea class="textarea" v-model="notice" placeholder="请输入内容"></textarea>
    </div>
    <div class="dataresbox" v-if="typeindex===0">
      <p class="title">数据库配置：</p>
      <ul>
        <li>
          <span class="tit">类型: </span>
          <div class="box">
            <slector style="width:190px;" title="模板" :columns="baseSql.typeDrow" :value.sync="baseSql.type"></slector>
          </div>
        </li>
        <li>
          <span class="tit">I P: </span>
          <div class="box">
            <span class="inp">
              <input v-model="baseSql.ip" placeholder="请输入更改名称">
            </span>
          </div>
        </li>
        <li>
          <span class="tit">端口: </span>
          <div class="box">
            <span class="inp">
              <input v-model="baseSql.port" placeholder="请输入更改名称">
            </span>
          </div>
        </li>
        <li>
          <span class="tit">用户名: </span>
          <div class="box">
            <span class="inp">
              <input v-model="baseSql.user" placeholder="请输入更改名称">
            </span>
          </div>
        </li>
        <li>
          <span class="tit">密码: </span>
          <div class="box">
            <span class="inp">
              <input type="password" v-model="baseSql.pwd" placeholder="请输入更改名称">
            </span>
          </div>
        </li>
        <li>
          <span class="tit">S Q L: </span>
          <div class="box">
            <textarea class="textarea" v-model="baseSql.sql" placeholder="UPDATE 数据库名.表名 SET 游戏币字段 = 游戏币字段 + @SUM @WHERE 账号字段 = @USER@"></textarea>
            <p class="txt">1.多条sql请用";"隔开 2.账号变量:@USER@ 游戏币数量:@SUM@</p>
          </div>
        </li>
      </ul>
    </div>
    <dl class="clearfix mgt10">
      <dt>定时开区：</dt>
      <dd>
        <time-selct class="width190" :value.sync="setTime"></time-selct>
        <p class="txt">系统将在指定时间开始提供充值服务</p>
      </dd>
    </dl>
    <p class="t_c" v-if="typeindex!==3&&typeindex!==0">
      <span style="display:inline-block;">
        <!-- <van-checkbox v-model="iscreatjb" shape="square" checked-color="#1abc9c">创建脚本，系统将在您服务器上创建充值脚本</van-checkbox> -->
        <van-radio-group v-model="iscreatjb" direction="horizontal">
          <van-radio class="mgb5" :name="0" checked-color="#07c160">不更新脚本</van-radio>
          <van-radio class="mgb5" :name="1" checked-color="#07c160">仅更新充值脚本</van-radio>
          <van-radio class="mgb5" :name="2" checked-color="#07c160">全部更新</van-radio>
        </van-radio-group>
      </span>
    </p>
    <p class="tip_text" style="margin-left:-10px;" v-if="typeindex!==3&&typeindex!==0">如果现在不需要创建脚本，您可以在分区管理中加载脚本</p>
    <p class="t_c mgt20">
      <van-button color="linear-gradient(to bottom, #3de9a9, #23cc9a)" @click="partinstall"><span class="pdl30 pdr30">保存</span></van-button>
    </p>
  </div>
</template>

<script>
import timeSelct from '../components/timeSelct1';
import slector from '../components/slector1';
export default {
  components: {
    timeSelct,
    slector
  },
  data() {
    return {
      installFlag: true, // 保存按钮中的防重复点击
      typeindex: 1, // 分区类型
      partName: '', // 分区名称
      partChecked: false, // 在指定时间更改分区名称
      changeName: '', // 更改名称
      changeTime: this.getNewTime(), // 更改时间
      checked: false, // check全选
      grouplist: [], // 分组被选的list
      areaList: [], // 分组列表
      serverIp: '', // 网关标识
      serverDrow: [], // 网关下拉
      installPath: 'D:\\MirServer', // 安装路径
      modelDrow: [], // 模板list
      installModel: '', // 模板
      glodEgg: true, // 元宝蛋
      notice: '', // 分区公告
      baseSql: {
        type: 0, // 类型
        typeDrow: [
          { text: 'MySQL', value: 0 },
          { text: 'SQL Server', value: 2 }
        ], // 类型列表
        ip: '', // ip
        port: '', // 端口
        user: '', // 用户名
        pwd: '', // 用户名
        sql: '' // SQL
      },
      setTime: this.getNewTime(), // 定时开区
      iscreatjb: 1 // 创建脚本
    };
  },
  watch: {
    grouplist(n, o) {
      console.log(n, '125441');
    }
  },
  methods: {
    // 分区类型的切换
    changeType(index) {
      this.typeindex = index;
      this.installModel = '';
      this.modelDrowList();
      if (index === 3) {
        this.glodEgg = true;
        this.iscreatjb = 1;
      } else if (index === 0) {
        this.installPath = 'D:\\MirServer';
      }
    },
    // 分组的全选按钮toggle
    checkedtoggle(val) {
      if (val) {
        this.$refs.checkboxGroup.toggleAll(true);
      } else {
        this.$refs.checkboxGroup.toggleAll(false);
      }
    },
    // 获取用户分组
    groupsdrow() {
      this.$api.home
        .groupsdrow()
        .then((data) => {
          this.areaList = data.data;
        })
        .catch((err) => {
          this.$toast.fail(err.message);
        });
    },
    // 获取服务器机器码
    getequipcode() {
      this.$api.home
        .getMachineCode()
        .then((data) => {
          if (data.status === 200) {
            this.serverDrow = data.data.map((item) => {
              return {
                text: item.name,
                value: item.machineCode
              };
            });
          }
        })
        .catch((err) => {
          this.$toast.fail(err.message);
        });
    },
    // 获取用户模板下拉
    modelDrowList() {
      this.$api.home
        .modelDrow({ templatesType: this.typeindex })
        .then((data) => {
          if (data.status === 200) {
            this.modelDrow = data.data.map((item) => {
              return {
                text: item.name,
                value: item.id
              };
            });
          } else {
            this.modelDrow = [];
          }
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    // 安装时，数据的检验
    dataChecked() {
      if (this.partName === '') {
        this.$toast('请填写分区名称');
        return true;
      } else if (this.partChecked && this.changeName === '') {
        this.$toast('请填写更改名称');
        return true;
      } else if (this.partChecked && this.changeTime === '') {
        this.$toast('请选择更改时间');
        return true;
      } else if (JSON.stringify(this.grouplist) === '[]') {
        this.$toast('请选择游戏分组');
        return true;
      } else if (this.serverIp === '') {
        this.$toast('请输入机器码');
        return true;
      } else if (this.typeindex !== 0 && this.installPath === '') {
        this.$toast('请输入安装地址');
        return true;
      } else if (this.installModel === '') {
        this.$toast('请选择模板');
        return true;
      } else if (this.typeindex === 0 && this.baseSql.type === '') {
        this.$toast('请选择数据库类型');
        return true;
      } else if (this.typeindex === 0 && this.baseSql.ip === '') {
        this.$toast('请输入数据库ip');
        return true;
      } else if (this.typeindex === 0 && this.baseSql.port === '') {
        this.$toast('请输入数据库端口');
        return true;
      } else if (this.typeindex === 0 && this.baseSql.user === '') {
        this.$toast('请输入数据库用户名');
        return true;
      } else if (this.typeindex === 0 && this.baseSql.pwd === '') {
        this.$toast('请输入数据库密码');
        return true;
      } else if (this.typeindex === 0 && this.baseSql.sql === '') {
        this.$toast('请输入数据库SQL');
        return true;
      }
      return false;
    },
    // 安装分区
    partinstall() {
      if (this.installFlag) {
        this.installFlag = false;
        let flag = this.dataChecked();
        if (flag) {
          this.installFlag = true;
          return;
        }
        this.$toast.loading({
          duration: 0,
          message: '加载中...',
          forbidClick: true
        });
        this.$api.home
          .partInstall({
            type: this.typeindex, // 分区类型
            dataFormat: '', // web通讯中数据格式
            dbInfo: {
              type: this.baseSql.type,
              ip: this.baseSql.ip,
              port:
                this.baseSql.port === '' ? 0 : parseFloat(this.baseSql.port),
              user: this.baseSql.user,
              pwd: this.baseSql.pwd,
              sql: this.baseSql.sql
            }, // 数据库配置对象
            isChangeInTime: this.partChecked, // 是否在指定时间更改分区名称
            useName: this.changeName, // 更改名称
            changeDate: this.changeTime, // 更改时间
            name: this.partName, // 分区名称
            notice: this.notice, // 分区公告
            noticeState: true, // 默认参数    *页面无对应*
            scriptPath: this.typeindex === 0 ? '' : this.installPath, // 安装路径
            machineCode: this.serverIp, // 服务器ip
            serverPort: 0, // 服务器端口
            sort: 0, // 默认参数    *页面无对应*
            state: true, // 默认参数    *页面无对应*
            successMark: '', // web通讯中成功标识
            useDate: this.setTime, // 定时开区
            uuid: '', // 默认参数    *页面无对应*
            webUrl: '', // web通讯中服务地址
            ybEgg: this.glodEgg, // 是否开启元宝蛋
            applicationUserId: 0, // 默认参数    *页面无对应*
            templateId: this.installModel, // 模板编号
            groups: this.grouplist.map((item) => {
              return { id: item };
            }),
            partitionCmdType: this.iscreatjb // 是否创建脚本
          })
          .then((data) => {
            if (data.status === 200) {
              this.$toast.clear();
              this.dataInit();
              this.$toast.success('安装成功');
              this.installFlag = true;
            }
          })
          .catch((err) => {
            this.$toast.clear();
            this.installFlag = true;
            this.$toast(err.message);
          });
      }
    },
    // 安装成功后，页面数据初始化
    dataInit() {
      this.typeindex = 1; // 分区类型
      this.partName = ''; // 分区名称
      this.partChecked = false; // 在指定时间更改分区名称
      this.changeName = ''; // 更改名称
      this.changeTime = this.getNewTime(); // 更改时间
      this.grouplist = []; // 分组被选的list
      this.checked = false; // check全选
      // this.serverIp = ''; // 服务器IP EMKEMEMM333336KCM32M19K2
      // this.serverPort = 6379; // 通讯端口
      this.installPath = 'D:\\MirServer'; // 安装路径
      this.installModel = ''; // 模板
      this.glodEgg = true; // 元宝蛋
      this.notice = ''; // 分区公告
      // sql通用
      this.baseSql.type = 0; // 类型
      this.baseSql.ip = ''; // ip
      this.baseSql.port = ''; // 端口
      this.baseSql.user = ''; // 用户名
      this.baseSql.pwd = ''; // 用户名
      this.baseSql.sql = ''; // SQL

      this.setTime = this.getNewTime(); // 定时开区
      this.iscreatjb = 1; // 创建脚本
    }
  },
  created() {
    this.groupsdrow();
    this.getequipcode();
    this.modelDrowList();
  }
};
</script>

<style lang="scss" scoped>
.installBox {
  .mgb5 {
    margin-bottom: 5px;
  }
  padding: 0 30px 30px;
  height: 100%;
  overflow-y: auto;
  &::v-deep .van-checkbox {
    .van-checkbox__label {
      color: #666;
      font-size: 13px;
    }
    .van-checkbox__icon {
      .van-icon {
        border-radius: 4px;
      }
    }
  }
  .inp {
    display: inline-block;
    margin-right: 10px;
    background: #fff;
    border-radius: 4px;
    color: #b1b1b1;
    font-size: 14px;
    input {
      display: block;
      border: none;
      outline: none;
      width: 100px;
      height: 30px;
      padding: 0 10px;
      width: 100%;
      border-radius: 4px;
      border: 1px solid #dbd8d8;
      &:focus {
        border-color: #1abc9c;
      }
      &::placeholder {
        color: #bbb;
      }
    }
  }
  .toptit {
    font-size: 17px;
    color: #666;
    padding-top: 30px;
    margin-bottom: 10px;
  }
  .typeContainer {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    span {
      width: 73px;
      height: 28px;
      line-height: 29px;
      color: #626262;
      font-size: 13px;
      border: 1px solid #0cbb93;
      border-radius: 3px;
      text-align: center;
      &.on {
        background: linear-gradient(to bottom, #3de9a9, #23cc9a);
        border-color: transparent;
        color: #fff;
      }
    }
  }
  .tip_text {
    font-size: 13px;
    color: #ff0101;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  dl {
    margin-bottom: 10px;
    dt {
      float: left;
      font-size: 17px;
      color: #666;
      height: 30px;
      line-height: 30px;
      text-align: right;
      min-width: 100px;
    }
    dd {
      float: left;
      .txt {
        color: #666;
        font-size: 10px;
        margin-top: 8px;
      }
    }
  }
  .checkList {
    max-height: 100px;
    overflow-y: auto;
    li {
      float: left;
      margin-left: 15px;
      margin-bottom: 10px;
    }
  }
  .noticebox {
    .txt {
      font-size: 17px;
      color: #5c5c5c;
      margin-bottom: 5px;
    }
    .textarea {
      display: block;
      padding: 5px 10px;
      width: 100%;
      height: 100px;
      border: 1px solid #dbd8d8;
      border-radius: 4px;
      font-size: 13px;
      &:focus {
        border-color: #0cbb93;
      }
    }
  }
  .dataresbox {
    margin-top: 10px;
    .title {
      font-size: 17px;
      color: #5c5c5c;
      margin-bottom: 8px;
    }
    ul {
      li {
        display: flex;
        flex-flow: row nowrap;
        margin-bottom: 8px;
        .tit {
          width: 60px;
          padding-right: 10px;
          text-align: right;
          font-size: 13px;
          color: #0cbb93;
          height: 30px;
          line-height: 30px;
        }
        .textarea {
          display: block;
          padding: 5px 10px;
          width: 240px;
          height: 100px;
          border: 1px solid #dbd8d8;
          border-radius: 4px;
          font-size: 13px;
          &::placeholder {
            color: #ccc;
          }
          &:focus {
            border-color: #0cbb93;
          }
        }
        .txt {
          color: #999;
          margin-top: 5px;
        }
      }
    }
  }
}
</style>
